import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'
import { Card as BaseCard, InfoIcon as Info } from '@chilecompra/react-kit/components'
import { PUBLIC_URL } from '../../config/settings/environment'
import theme from '../../config/styles/theme'

export const Airlines = styled('div')`
  background: ${theme.palette.custom.background};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0 16px 40px;
`
export const AirlineLogo = styled(({ ...props }) => <img {...props} />)`
  height: 180px;
  object-fit: scale-down;
  width: 100%;
`
export const Banner = styled('div')`
  align-items: center;
  background: url('${PUBLIC_URL}/assets/images/img-cmpasajes.png');
  background-position: top left;
  background-size: cover;
  border-radius: 0;
  display: flex;
  height: 300px;
  margin: 0;
  width: 100%;
`
export const BannerBlock = styled('div')`
  margin: 0 auto;
  max-width: 360px;
  padding: 0 0 0 50px;
  width: 100%;
  ${props => props.theme.breakpoints.up('sm')} {
    max-width: 680px;
    padding: 0 0 0 135px;
  }
  ${props => props.theme.breakpoints.up('md')} {
    max-width: 960px;
  }
  ${props => props.theme.breakpoints.up('lg')} {
    max-width: 1280px;
  }
`
export const BannerTitle = styled('h2')`
  color: ${props => props.theme.palette.brand.white};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 27px;
  font-weight: 700;
  line-height: 31px;
  margin-top: 0;
  max-width: 250px;
`
export const Column = styled(({ ...props }) => <BaseGrid item {...props} />)``
export const HowItWorks = styled('div')`
  background: ${props => props.theme.palette.brand.white};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0 16px 40px;
`
export const InfoIcon = styled(Info)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.yellow[50]};
    height: 22px;
    width: 22px;
  }
`
export const Image = styled('img')`
  height: ${props => props.height};
  width: ${props => props.width};
`
export const LinkHelp = styled('a')`
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;
  display: flex;
  justify-content: ${props => props.justifyContent};
  text-decoration: underline;
`
export const ManualLogo = styled(({ ...props }) => <img {...props} />)`
  max-width: 68px;
  margin-bottom: 16px;
  ${props => props.theme.breakpoints.up('md')} {
    margin-bottom: 0;
  }
`
export const NotAvailable = styled('div')`
  background: ${props => props.theme.palette.brand.gray3};
  border-radius: 4px;
  margin: -16px 0;
  max-width: 250px;
  padding: 16px 40px;
  text-align: center;
`
export const Root = styled('div')`
  margin: 0 auto;
  padding: 0;
  width: 100%;
`
export const Row = styled(({ margin, padding, ...props }) => <BaseGrid container {...props} />)`
  margin-top: 0;
  max-width: 360px;
  padding: ${props => props.padding};
  width: 100%;
  ${props => props.theme.breakpoints.up('sm')} {
    max-width: 680px;
  }
  ${props => props.theme.breakpoints.up('md')} {
    max-width: 960px;
  }
  ${props => props.theme.breakpoints.up('lg')} {
    max-width: 1280px;
  }
`
export const StepCard = styled(({ ...props }) => <BaseCard {...props} />)`
  &.MuiPaper-root {
    background: ${props => props.theme.palette.brand.white};
    border-color: ${props => props.theme.palette.brand.gray2};
    border-style: solid;
    border-width: 1px;
    height: 100%;
    min-height: 227px;
    ${props => props.theme.breakpoints.up('sm')} {
      min-height: 255px;
    }
    > div {
      padding: 24px 30px;
    }
  }
`
export const StepIcon = styled('div')`
  align-items: center;
  background: ${props => props.theme.palette.brand.primary};
  border-radius: 50%;
  color: ${props => props.theme.palette.brand.white};
  display: flex;
  font-weight: 700;
  height: 32px;
  justify-content: center;
  width: 32px;
`
